// extracted by mini-css-extract-plugin
export var imageContainer = "styles-mod--image-container--d603a";
export var logoListContainer = "styles-mod--logo-list-container--5fc36";
export var swiperSlide = "styles-mod--swiper-slide--a7701";
export var swiperWrapper = "styles-mod--swiper-wrapper--6177f";